import { LayoutContainer, LayoutText, LayoutHTMLText } from '@pixi/layout/components'; // eslint-disable-line
import * as PIXI from 'pixi.js';
import { DropShadowFilter} from 'pixi-filters';
import { APP_WIDTH, APP_HEIGHT, CARD_WIDTH, CARD_HEIGHT, getProxiedCardImageUrl } from '../utils/commonUtils';
import { getGlobalEventEmitter } from '../utils/globalEventEmitter';
import AssetsLoader from '../utils/assetsLoader';

const SCALE_FACTOR = 3.6;

function escapeHtml(unsafe) {
    return unsafe
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&#039;");
}

export default class CardInfoContainer extends PIXI.Container {
    constructor() {
        super();

        const gradient1 = new PIXI.FillGradient({
            type: 'linear',
            colorStops: [
              { offset: 0, color: 'rgb(13, 13, 13)' },
              { offset: 0.5, color: 'rgba(36, 36, 36, 0.9)' },
              { offset: 1, color: 'rgb(13, 13, 13)' },
            ],
          });

        const gradient2 = new PIXI.FillGradient({
            type: 'linear',
            start: { x: 0, y: 0.5 },
            end: { x: 1, y: 0.5 },
            colorStops: [
              { offset: 0, color: 'rgb(0, 0, 0)' },
              { offset: 0.1, color: 'rgba(1, 1, 1, 0)' },
              { offset: 0.9, color: 'rgba(1, 1, 1, 0)' },
              { offset: 1, color: 'rgb(0, 0, 0)' },
            ],
          });

        this.screenWidth = APP_WIDTH;
        this.screenHeight = APP_HEIGHT;
        this.overlayFill = gradient1;
        this.overlayEdgeFill = gradient2;


        const cardInfoOverlayGraphics = new PIXI.Graphics();
        cardInfoOverlayGraphics.label = 'cardInfoOverlayGraphics';
        cardInfoOverlayGraphics.x = 0;
        cardInfoOverlayGraphics.y = 0;
        cardInfoOverlayGraphics.rect(-APP_WIDTH / 2, -APP_HEIGHT / 2, APP_WIDTH, APP_HEIGHT);
        cardInfoOverlayGraphics.fill(gradient1);
        cardInfoOverlayGraphics.rect(-APP_WIDTH / 2 - 50, -APP_HEIGHT / 2, APP_WIDTH + 100, APP_HEIGHT);
        cardInfoOverlayGraphics.fill(gradient2);
        cardInfoOverlayGraphics.eventMode = 'static';
        // cardInfoOverlayGraphics.alpha = 0.9;
        this.addChild(cardInfoOverlayGraphics);

        const cardContainer = new PIXI.Container();
        cardContainer.label = 'cardContainer';
        cardContainer.scale.set(SCALE_FACTOR);
        cardContainer.x = 0;
        cardContainer.y = -480;
        cardContainer.filters = [new DropShadowFilter({
            color: '#000000',
            alpha: 1,
            blur: 10,
            distance: 10,
            quality: 16,
            shadowOnly: false,
        })];
        this.addChild(cardContainer);

        const cardSprite = new PIXI.Sprite();
        cardSprite.label = 'cardSprite';
        cardSprite.width = CARD_WIDTH;
        cardSprite.height = CARD_HEIGHT;
        cardSprite.anchor.set(0.5);
        cardContainer.addChild(cardSprite);

        const titleTextContainer = new LayoutContainer({
            layout: {
                width: APP_WIDTH,
                height: 70,
                alignItems: 'center',
                justifyContent: 'center',
                gap: 10,
            }
        });
        titleTextContainer.label = 'titleTextContainer';
        titleTextContainer.x = -APP_WIDTH / 2;
        titleTextContainer.y = 170;
        this.addChild(titleTextContainer);

        const leaderIcon = new PIXI.Sprite(PIXI.Assets.get(AssetsLoader.eDefaultAssetsAliases.CARD_INFO_LEADER_ICON));
        leaderIcon.layout = { width: 70, height: 70 };
        leaderIcon.label = 'leaderIcon';
        leaderIcon.visible = false;
        titleTextContainer.addChild(leaderIcon);

        const characterIcon = new PIXI.Sprite(PIXI.Assets.get(AssetsLoader.eDefaultAssetsAliases.CARD_INFO_CHARACTER_ICON));
        characterIcon.layout = { width: 70, height: 70 };
        characterIcon.label = 'characterIcon';
        characterIcon.visible = false;
        titleTextContainer.addChild(characterIcon);

        const stageIcon = new PIXI.Sprite(PIXI.Assets.get(AssetsLoader.eDefaultAssetsAliases.CARD_INFO_STAGE_ICON));
        stageIcon.layout = { width: 70, height: 70 };
        stageIcon.label = 'stageIcon';
        stageIcon.visible = false;
        titleTextContainer.addChild(stageIcon);

        const eventIcon = new PIXI.Sprite(PIXI.Assets.get(AssetsLoader.eDefaultAssetsAliases.CARD_INFO_EVENT_ICON));
        eventIcon.layout = { width: 70, height: 70 };
        eventIcon.label = 'eventIcon';
        eventIcon.visible = false;
        titleTextContainer.addChild(eventIcon);

        const titleText = new PIXI.Text({
            text: 'Card Title',
            style: {
                fontFamily: 'Open Sans',
                fontSize: 49,
                fill: '#ffffff',
                fontWeight: '600',
            },
            layout: {
                height: 70,
                objectFit: 'none',
                objectPosition: 'center',
            }
        });
        titleText.layout = { width: titleText.width };
        titleText.label = 'titleText';
        titleTextContainer.addChild(titleText);

        this.lineFill = new PIXI.FillGradient({
            type: 'linear',
            start: { x: 0, y: 0.5 },
            end: { x: 1, y: 0.5 },
            colorStops: [
              { offset: 0, color: 'rgba(255, 255, 255, 0)' },
              { offset: 0.25, color: 'rgba(255, 255, 255, 1)' },
              { offset: 0.75, color: 'rgba(255, 255, 255, 1)' },
              { offset: 1, color: 'rgba(255, 255, 255, 0)' },
            ],
          });

        const lineGraphics1 = new PIXI.Graphics();
        lineGraphics1.label = 'lineGraphics1';
        lineGraphics1.x = 0;
        lineGraphics1.y = 250;
        lineGraphics1.rect(-APP_WIDTH / 2 + 50, -2, APP_WIDTH - 100, 4);
        lineGraphics1.fill(this.lineFill);
        this.addChild(lineGraphics1);

        const effectText = new LayoutHTMLText({
            text: 'Effect Text',
            style: {
                fontSize: 38,
                fontFamily: 'OpenSans',
                fontWeight: '600',
                fill: '#ffffff',
                wordWrap: true,
                lineHeight: 58,
                align: 'center',
                cssOverrides: [
                    `.blue { color:rgb(80, 125, 250); }`,
                    `.red { color:rgb(250, 80, 80); }`,
                    `.orange { color:rgb(250, 125, 80); }`
                ]
            },
            layout: {
                height: 200,
                width: APP_WIDTH - 140,
                objectPosition: 'top',
                objectFit: 'none', // uncomment this to allow the text to scroll
                overflow: 'scroll',
                padding: 0,
            }
        });
        effectText.label = 'effectText';
        effectText.x = -APP_WIDTH / 2 + 70;
        effectText.y = 290;
        effectText.slot.layout = { height: 'intrinsic' };
        this.addChild(effectText);

        // after creating effectTextContainer
        const bar = new PIXI.Graphics({ label: 'vScroll' });
        bar.x = APP_WIDTH / 2 - 50;
        bar.y = 290;
        this.addChild(bar);

        this.scrollTicker = () => {
            // sizes
            const vpH = effectText.layout?.computedLayout.height;
            const vpW = effectText.layout?.computedLayout.width;

            // access trackpad (internal)
            const yAxis = effectText._trackpad.yAxis;
            const max = yAxis.max;          // <= 0
            const val = yAxis.value;        // 0 .. max
            const contentH = vpH - max;     // since max = -(contentH - vpH)

            bar.clear();

            // no overflow => hide
            if (contentH <= vpH) return;

            // track + thumb
            const trackW = 22;
            const trackR = 10;
            const trackH = vpH;

            const ratio = vpH / contentH;
            const thumbH = Math.max(24, trackH * ratio);

            const t = -val / -max;          // 0 at top, 1 at bottom
            const thumbY = (trackH - thumbH) * t;

            // draw track
            bar.roundRect(0, 0, trackW, trackH, trackR).fill({ color: '#000000', alpha: 1 }).stroke({ color: '#244e67', alpha: 1, width: 4 });

            // draw thumb
            bar.roundRect(0 + 5, thumbY + 5, trackW - 10, thumbH - 10, trackR).fill({ color: '#ddc341', alpha: 1 });
        }

        PIXI.Ticker.shared.add(this.scrollTicker);

        const lineGraphics2 = new PIXI.Graphics();
        lineGraphics2.label = 'lineGraphics2';
        lineGraphics2.x = 0;
        lineGraphics2.y = 530;
        lineGraphics2.rect(-APP_WIDTH / 2 + 50, -2, APP_WIDTH - 100, 4);
        lineGraphics2.fill(this.lineFill);
        this.addChild(lineGraphics2);

        const attributesContainer = new PIXI.Container();
        attributesContainer.label = 'attributesContainer';
        attributesContainer.x = 0;
        attributesContainer.y = 0;
        this.addChild(attributesContainer);

        const colorTitleText = new PIXI.Text({
            text: 'Color',
            style: {
                fontSize: 38,
                fontFamily: 'Open Sans',
                fontWeight: '700',
                fill: '#ddc341',
            },
        });
        colorTitleText.label = 'colorTitleText';
        colorTitleText.x = -APP_WIDTH / 2 + 70;
        colorTitleText.y = 560;
        attributesContainer.addChild(colorTitleText);

        const colorTextContainer = new LayoutContainer({
            layout: {
                width: APP_WIDTH,
                height: 44,
                objectPosition: 'top left',
            }
        });
        colorTextContainer.label = 'colorTextContainer';
        colorTextContainer.x = -APP_WIDTH / 2 + 295;
        colorTextContainer.y = 560;
        attributesContainer.addChild(colorTextContainer);

        const colorText = new PIXI.Text({
            text: 'Color',
            style: {
                fontSize: 38,
                fontFamily: 'Open Sans',
                fontWeight: '700',
                fill: '#ffffff',
            },
        });
        colorText.layout = { width: colorText.width, height: colorText.height, objectFit: 'none' };
        colorTextContainer.layout = { height: colorText.height };
        colorText.label = 'colorText';
        colorTextContainer.addChild(colorText);

        const purpleColorGraphics = new PIXI.Graphics({ layout: { width: 30, height: 44, objectFit: 'none' } });
        purpleColorGraphics.label = 'purpleColorGraphics';
        purpleColorGraphics.x = 15;
        purpleColorGraphics.y = 0;
        purpleColorGraphics.circle(0, 0, 15);
        purpleColorGraphics.fill({ color: '#800080', alpha: 1 });
        purpleColorGraphics.visible = false;
        colorTextContainer.addChild(purpleColorGraphics);

        const redColorGraphics = new PIXI.Graphics({ layout: { width: 30, height: 44, objectFit: 'none' } });
        redColorGraphics.label = 'redColorGraphics';
        redColorGraphics.x = 15;
        redColorGraphics.y = 0;
        redColorGraphics.circle(0, 0, 15);
        redColorGraphics.fill({ color: '#d11c27', alpha: 1 });
        redColorGraphics.visible = false;
        colorTextContainer.addChild(redColorGraphics);

        const categoryTitleText = new PIXI.Text({
            text: 'Category',
            style: {
                fontSize: 38,
                fontFamily: 'Open Sans',
                fontWeight: '700',
                fill: '#ddc341',
            },
        });
        categoryTitleText.label = 'categoryTitleText';
        categoryTitleText.x = -APP_WIDTH / 2 + 70;
        categoryTitleText.y = 630;
        attributesContainer.addChild(categoryTitleText);

        const categoryText = new PIXI.Text({
            text: 'Category',
            style: {
                fontSize: 38,
                fontFamily: 'Open Sans',
                fontWeight: '700',
                fill: '#ffffff',
            },
        });
        categoryText.label = 'categoryText';
        categoryText.x = -APP_WIDTH / 2 + 295;
        categoryText.y = 630;
        attributesContainer.addChild(categoryText);

        const costLifeTitleText = new PIXI.Text({
            text: 'Cost/Life',
            style: {
                fontSize: 38,
                fontFamily: 'Open Sans',
                fontWeight: '700',
                fill: '#ddc341',
            },
        });
        costLifeTitleText.label = 'costLifeTitleText';
        costLifeTitleText.x = -APP_WIDTH / 2 + 70;
        costLifeTitleText.y = 700;
        attributesContainer.addChild(costLifeTitleText);

        const costLifeText = new PIXI.Text({
            text: 'Cost/Life',
            style: {
                fontSize: 38,
                fontFamily: 'Open Sans',
                fontWeight: '700',
                fill: '#ffffff',
            },
        });
        costLifeText.label = 'costLifeText';
        costLifeText.x = -APP_WIDTH / 2 + 295;
        costLifeText.y = 700;
        attributesContainer.addChild(costLifeText);

        const typeTitleText = new PIXI.Text({
            text: 'Type',
            style: {
                fontSize: 38,
                fontFamily: 'Open Sans',
                fontWeight: '700',
                fill: '#ddc341',
            },
        });
        typeTitleText.label = 'typeTitleText';
        typeTitleText.x = -APP_WIDTH / 2 + 70;
        typeTitleText.y = 770;
        attributesContainer.addChild(typeTitleText);

        const typeText = new LayoutText({
            text: 'Type',
            style: {
                fontSize: 38,
                fontFamily: 'Open Sans',
                fontWeight: '700',
                fill: '#ffffff',
            },
            layout: {
                height: 44,
                width: APP_WIDTH - 70 - 295,
                objectPosition: 'center left',
            }
        });
        typeText.label = 'typeText';
        typeText.x = -APP_WIDTH / 2 + 295;
        typeText.y = 770;
        attributesContainer.addChild(typeText);

        const powerTitleText = new PIXI.Text({
            text: 'Power',
            style: {
                fontSize: 38,
                fontFamily: 'Open Sans',
                fontWeight: '700',
                fill: '#ddc341',
            },
        });
        powerTitleText.label = 'powerTitleText';
        powerTitleText.x = -APP_WIDTH / 2 + 640;
        powerTitleText.y = 560;
        attributesContainer.addChild(powerTitleText);

        const powerText = new PIXI.Text({
            text: 'Power',
            style: {
                fontSize: 38,
                fontFamily: 'Open Sans',
                fontWeight: '700',
                fill: '#ffffff',
            },
        });
        powerText.label = 'powerText';
        powerText.x = -APP_WIDTH / 2 + 845;
        powerText.y = 560;
        attributesContainer.addChild(powerText);

        const counterTitleText = new PIXI.Text({
            text: 'Counter',
            style: {
                fontSize: 38,
                fontFamily: 'Open Sans',
                fontWeight: '700',
                fill: '#ddc341',
            },
        });
        counterTitleText.label = 'counterTitleText';
        counterTitleText.x = -APP_WIDTH / 2 + 640;
        counterTitleText.y = 630;
        attributesContainer.addChild(counterTitleText);
        
        const counterText = new PIXI.Text({
            text: 'Counter',
            style: {
                fontSize: 38,
                fontFamily: 'Open Sans',
                fontWeight: '700',
                fill: '#ffffff',
            },
        });
        counterText.label = 'counterText';
        counterText.x = -APP_WIDTH / 2 + 845;
        counterText.y = 630;
        attributesContainer.addChild(counterText);

        const attributeTitleText = new PIXI.Text({
            text: 'Attribute',
            style: {
                fontSize: 38,
                fontFamily: 'Open Sans',
                fontWeight: '700',
                fill: '#ddc341',
            },
        });
        attributeTitleText.label = 'attributeTitleText';
        attributeTitleText.x = -APP_WIDTH / 2 + 640;
        attributeTitleText.y = 700;
        attributesContainer.addChild(attributeTitleText);
        
        const attributeText = new PIXI.Text({
            text: 'Attribute',
            style: {
                fontSize: 38,
                fontFamily: 'Open Sans',
                fontWeight: '700',
                fill: '#ffffff',
            },
        });
        attributeText.label = 'attributeText';
        attributeText.x = -APP_WIDTH / 2 + 845;
        attributeText.y = 700;
        attributesContainer.addChild(attributeText);

        const wavesFooter = new PIXI.Sprite(PIXI.Assets.get(AssetsLoader.eDefaultAssetsAliases.WAVES_FOOTER));
        wavesFooter.label = 'wavesFooter';
        wavesFooter.x = 0;
        wavesFooter.y = APP_HEIGHT / 2;
        wavesFooter.anchor.set(0.5, 1);
        this.addChild(wavesFooter);

        const closeCardInfoX = new PIXI.Sprite(PIXI.Assets.get(AssetsLoader.eDefaultAssetsAliases.CLOSE_CARD_INFO_X));
        closeCardInfoX.label = 'closeCardInfoX';
        closeCardInfoX.anchor.set(0.5, 0.5);
        closeCardInfoX.x = 0;
        closeCardInfoX.y = 950;

        closeCardInfoX.eventMode = 'static';
        closeCardInfoX.on('pointerdown', (event) => {
            event.stopPropagation();
            getGlobalEventEmitter()?.emit('closeCardInfo');
            this.onCloseClicked?.();
        });
        this.addChild(closeCardInfoX);

    }

    resize(width, height) {
        if (this.screenWidth === width && this.screenHeight === height) return;
        this.screenWidth = width;
        this.screenHeight = height;

        const overlay = this.getChildByLabel('cardInfoOverlayGraphics');
        overlay.clear();
        overlay.rect(-width / 2, -height / 2, width, height);
        overlay.fill(this.overlayFill);
        overlay.rect(-width / 2 - 50, -height / 2, width + 100, height);
        overlay.fill(this.overlayEdgeFill);

        const titleTextContainer = this.getChildByLabel('titleTextContainer');
        titleTextContainer.x = -width / 2;
        titleTextContainer.layout.setStyle({ width });

        for (const label of ['lineGraphics1', 'lineGraphics2']) {
            const line = this.getChildByLabel(label);
            line.clear();
            line.rect(-width / 2 + 50, -2, width - 100, 4);
            line.fill(this.lineFill);
        }

        const effectText = this.getChildByLabel('effectText');
        effectText.x = -width / 2 + 70;
        effectText.layout.setStyle({ width: width - 140 });
        this.getChildByLabel('vScroll').x = width / 2 - 50;

        const leftTitleX = -width / 2 + 70;
        for (const label of ['colorTitleText', 'categoryTitleText', 'costLifeTitleText', 'typeTitleText']) {
            this.getChildByLabel(label, true).x = leftTitleX;
        }

        const leftValueX = -width / 2 + 295;
        for (const label of ['colorTextContainer', 'categoryText', 'costLifeText', 'typeText']) {
            this.getChildByLabel(label, true).x = leftValueX;
        }
        this.getChildByLabel('typeText', true).layout.setStyle({ width: width - 70 - 295 });

        const rightTitleX = width / 2 - (APP_WIDTH - 640);
        for (const label of ['powerTitleText', 'counterTitleText', 'attributeTitleText']) {
            this.getChildByLabel(label, true).x = rightTitleX;
        }

        const rightValueX = width / 2 - (APP_WIDTH - 845);
        for (const label of ['powerText', 'counterText', 'attributeText']) {
            this.getChildByLabel(label, true).x = rightValueX;
        }

        const wavesFooter = this.getChildByLabel('wavesFooter');
        wavesFooter.y = height / 2;
        if (wavesFooter.texture?.width) {
            wavesFooter.scale.x = width / wavesFooter.texture.width;
        }
    }

    destroy() {
        PIXI.Ticker.shared.remove(this.scrollTicker);
        super.destroy();
    }

    update(cardInstance) {
        console.log('cardInstance', cardInstance);
        const cardSprite = this.getChildByLabel('cardSprite', true);
        cardSprite.texture = PIXI.Assets.get(getProxiedCardImageUrl(cardInstance.imgUrl));

        const titleText = this.getChildByLabel('titleText', true);
        titleText.text = cardInstance.name;
        titleText.layout = { width: titleText.width };
        
        const leaderIcon = this.getChildByLabel('leaderIcon', true);
        const characterIcon = this.getChildByLabel('characterIcon', true);
        const stageIcon = this.getChildByLabel('stageIcon', true);
        const eventIcon = this.getChildByLabel('eventIcon', true);

        leaderIcon.visible = false;
        characterIcon.visible = false;
        stageIcon.visible = false;
        eventIcon.visible = false;

        if (cardInstance.type === 'Leader') {
            leaderIcon.visible = true;
        } else if (cardInstance.type === 'Character') {
            characterIcon.visible = true;
        } else if (cardInstance.type === 'Stage') {
            stageIcon.visible = true;
        } else if (cardInstance.type === 'Event') {
            eventIcon.visible = true;
        }

        if (cardInstance.effectText) {
            const effectText = this.getChildByLabel('effectText', true);
            effectText.visible = true;
            effectText._trackpad.yAxis.position = 0;
            let parsedEffectText = cardInstance.effectText;
            parsedEffectText = escapeHtml(parsedEffectText);
            parsedEffectText = parsedEffectText.replace(/(\[Activate: Main\])/g, '<span class="blue">$1</span>');
            parsedEffectText = parsedEffectText.replace(/(\[Once Per Turn\])/g, '<span class="red">$1</span>');
            parsedEffectText = parsedEffectText.replace(/(\[When Attacking\])/g, '<span class="blue">$1</span>');
            parsedEffectText = parsedEffectText.replace(/(\[Blocker\])/g, '<span class="orange">$1</span>');
            parsedEffectText = parsedEffectText.replace(/(\[On Play\])/g, '<span class="blue">$1</span>');
            effectText.slot.text = parsedEffectText;

            const lineGraphics2 = this.getChildByLabel('lineGraphics2', true);
            lineGraphics2.visible = true;

            const attributesContainer = this.getChildByLabel('attributesContainer', true);
            attributesContainer.y = 0;
        } else {
            const effectText = this.getChildByLabel('effectText', true);
            effectText.visible = false;

            const lineGraphics2 = this.getChildByLabel('lineGraphics2', true);
            lineGraphics2.visible = false;

            const attributesContainer = this.getChildByLabel('attributesContainer', true);
            attributesContainer.y = -260;
        }

        const colorText = this.getChildByLabel('colorText', true);
        const colorStr = cardInstance.color.join('/');
        colorText.text = colorStr;
        colorText.layout = { width: colorText.width };

        const redColorGraphics = this.getChildByLabel('redColorGraphics', true);
        const purpleColorGraphics = this.getChildByLabel('purpleColorGraphics', true);

        redColorGraphics.visible = false;
        purpleColorGraphics.visible = false;

        if (colorStr === 'Red') {
            redColorGraphics.visible = true;
        } else if (colorStr === 'Purple') { 
            purpleColorGraphics.visible = true;
        }

        const categoryText = this.getChildByLabel('categoryText', true);
        categoryText.text = cardInstance.type;

        const costLifeTitleText = this.getChildByLabel('costLifeTitleText', true);
        const costLifeText = this.getChildByLabel('costLifeText', true);
        if (cardInstance.type === 'Leader') {
            costLifeTitleText.text = 'Life';
            costLifeText.text = cardInstance.life || '-';
        } else {
            costLifeTitleText.text = 'Cost';
            costLifeText.text = cardInstance.cost || '-';
        }

        const typeText = this.getChildByLabel('typeText', true);
        typeText.slot.text = cardInstance.cardTraits.join('/');

        const powerText = this.getChildByLabel('powerText', true);
        powerText.text = cardInstance.power || '-';

        const counterText = this.getChildByLabel('counterText', true);
        counterText.text = cardInstance.counter || '-';

        const attributeText = this.getChildByLabel('attributeText', true);
        attributeText.text = cardInstance.attribute || '-';
    }
}